import React from 'react';
import { SearchIcon, FilterIcon } from 'lucide-react';
const MOCK_AUDIT = [{
  date: '2023-10-25 10:45:12',
  user: 'Juan Pérez',
  role: 'Recolector',
  action: 'Crear Recolección',
  detail: 'ID: REC-1042, Área: Emergencia',
  ip: '192.168.1.105'
}, {
  date: '2023-10-25 10:45:15',
  user: 'Juan Pérez',
  role: 'Recolector',
  action: 'Sincronización',
  detail: '1 registro enviado',
  ip: '192.168.1.105'
}, {
  date: '2023-10-25 09:30:00',
  user: 'Admin Usuario',
  role: 'Supervisor',
  action: 'Inicio de Sesión',
  detail: 'Login exitoso (Web)',
  ip: '10.0.0.50'
}, {
  date: '2023-10-25 09:35:22',
  user: 'Admin Usuario',
  role: 'Supervisor',
  action: 'Exportar Datos',
  detail: 'Reporte Excel: Recolecciones Hoy',
  ip: '10.0.0.50'
}, {
  date: '2023-10-24 16:20:10',
  user: 'Admin Usuario',
  role: 'Supervisor',
  action: 'Editar Catálogo',
  detail: 'Área actualizada: Bodega Antigua (Inactivo)',
  ip: '10.0.0.50'
}, {
  date: '2023-10-24 14:15:00',
  user: 'María Gómez',
  role: 'Recolector',
  action: 'Crear Recolección',
  detail: 'ID: REC-1038, Área: Maternidad',
  ip: '192.168.1.112'
}];
export function AuditLog() {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 flex flex-col h-full" data-id="element-328">
      <div className="p-6 border-b border-gray-200" data-id="element-329">
        <h2 className="text-lg font-bold text-gray-900 mb-4" data-id="element-330">
          Registro de Actividad
        </h2>
        <div className="flex gap-4" data-id="element-331">
          <div className="relative flex-1 max-w-md" data-id="element-332">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-333">
              <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-334" />
            </div>
            <input type="text" placeholder="Buscar por usuario, acción o detalle..." className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:outline-none" data-id="element-335" />
          </div>
          <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 bg-white hover:bg-gray-50" data-id="element-336">
            <FilterIcon className="w-4 h-4" data-id="element-337" />
            Filtros
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-auto" data-id="element-338">
        <table className="w-full text-left border-collapse" data-id="element-339">
          <thead className="bg-gray-50 sticky top-0" data-id="element-340">
            <tr className="text-gray-500 text-sm border-b border-gray-200" data-id="element-341">
              <th className="px-6 py-3 font-medium" data-id="element-342">Fecha / Hora</th>
              <th className="px-6 py-3 font-medium" data-id="element-343">Usuario</th>
              <th className="px-6 py-3 font-medium" data-id="element-344">Acción</th>
              <th className="px-6 py-3 font-medium" data-id="element-345">Detalle</th>
              <th className="px-6 py-3 font-medium" data-id="element-346">IP</th>
            </tr>
          </thead>
          <tbody className="text-sm" data-id="element-347">
            {MOCK_AUDIT.map((row, i) => <tr key={i} className="border-b border-gray-100 hover:bg-gray-50 font-mono text-xs" data-id="element-348">
                <td className="px-6 py-3 text-gray-600" data-id="element-349">{row.date}</td>
                <td className="px-6 py-3" data-id="element-350">
                  <span className="font-bold text-gray-900 font-sans" data-id="element-351">
                    {row.user}
                  </span>
                  <span className="block text-gray-500 font-sans" data-id="element-352">
                    {row.role}
                  </span>
                </td>
                <td className="px-6 py-3" data-id="element-353">
                  <span className="inline-flex items-center px-2 py-1 rounded bg-gray-100 text-gray-800 font-sans font-medium" data-id="element-354">
                    {row.action}
                  </span>
                </td>
                <td className="px-6 py-3 text-gray-700" data-id="element-355">{row.detail}</td>
                <td className="px-6 py-3 text-gray-400" data-id="element-356">{row.ip}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}